import {
  ADMIN_LOGIN_LOADING,
  STOP_ADMIN_LOGIN_LOADING,
  SET_LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  LOADING,
  STOP_LOADING,
  INQUIRY_FORM_CLOSE,
  INQUIRY_FORM_OPEN,
  CHANGE_THEME,
  SET_COVER,
} from "../types";

const initialState = {
  adminLoginLoading: false,
  loginError: null,
  animation: false,
  loading: false,
  inquiryForm: false,
  theme: {
    primary: localStorage.getItem('primary') || "#2196f3",
    secondary: localStorage.getItem('secondary') || "#f44336",
    // primary: localStorage.getItem('primary') || "blue",
    // secondary: localStorage.getItem('secondary') || "red",
  }
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_LOGIN_LOADING:
      return {
        ...state,
        adminLoginLoading: true,
      };
    case STOP_ADMIN_LOGIN_LOADING:
      return {
        ...state,
        adminLoginLoading: false,
      };
    case SET_LOGIN_ERROR:
      return {
        ...state,
        loginError: action.payload,
        animation: true,
      };
    case CLEAR_LOGIN_ERROR:
      return {
        ...state,
        loginError: null,
        animation: false,
      };

    case LOADING:
      return {
        ...state,
        loading: true,
      };

    case STOP_LOADING:
      return {
        ...state,
        loading: false,
      };

    case INQUIRY_FORM_OPEN:
      return {
        ...state,
        inquiryForm: true,
      };

    case INQUIRY_FORM_CLOSE:
      return {
        ...state,
        inquiryForm: false,
      };

    case CHANGE_THEME:
      localStorage.setItem("primary", action.payload.primaryColor);
      localStorage.setItem("secondary", action.payload.secondaryColor);
      return {
        ...state,
        theme: {
          ...state.theme,
          primary: action.payload.primaryColor,
          secondary: action.payload.secondaryColor,
        },
      };

    case SET_COVER:
      return {
        ...state,
        cover: action.payload,
      };

    default:
      return state;
  }
};

export default uiReducer;
